<div class="chart-wrapper">
    <canvas id="canvas1"></canvas>
</div>